import { Reveal, Overline } from "./anim";
import { TESTIMONIALS, TESTIMONIAL_IMG } from "@/data";

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative bg-ink-soft py-24 md:py-36 border-t border-line-d" data-testid="testimonials-section">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10">
        <Reveal className="mb-16 md:mb-20 max-w-2xl">
          <Overline>Evidence that this works</Overline>
          <h2 className="mt-6 font-display font-light text-4xl md:text-5xl lg:text-6xl text-sand tracking-tight leading-tight">
            What changes when people finally speak.
          </h2>
        </Reveal>

        <div className="grid grid-cols-12 gap-5">
          <Reveal className="col-span-12 lg:col-span-4">
            <div className="relative overflow-hidden h-64 lg:h-full min-h-[300px]">
              <img src={TESTIMONIAL_IMG} alt="" className="absolute inset-0 h-full w-full object-cover img-treatment" />
              <div className="absolute inset-0 bg-ink/40" />
            </div>
          </Reveal>

          <div className="col-span-12 lg:col-span-8 grid gap-5">
            {TESTIMONIALS.length === 0 ? (
              <Reveal>
                <figure className="border border-line-d p-8 md:p-12 bg-ink flex flex-col justify-center h-full" data-testid="testimonials-empty">
                  <blockquote className="font-display text-2xl md:text-3xl lg:text-4xl text-sand leading-snug">
                    The best proof of this work is the words of the people who've lived it.
                  </blockquote>
                  <p className="mt-6 text-muted-d text-base md:text-lg leading-relaxed max-w-xl">
                    We're gathering reflections from the teams and leaders we work with. Their voices will live here soon —
                    honest, and entirely their own.
                  </p>
                  <button
                    onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
                    className="mt-8 self-start font-mono text-[11px] tracking-[0.2em] uppercase text-terra hover:text-sand transition-colors duration-300"
                    data-testid="testimonials-empty-cta"
                  >
                    Be part of the first cohort →
                  </button>
                </figure>
              </Reveal>
            ) : (
              TESTIMONIALS.map((t, i) => (
                <Reveal key={t.name} delay={i * 0.08}>
                  <figure className="border border-line-d p-8 md:p-10 bg-ink hover:border-terra transition-colors duration-500" data-testid={`testimonial-${i}`}>
                    <blockquote className="font-display text-2xl md:text-3xl text-sand leading-snug">“{t.quote}”</blockquote>
                    <figcaption className="mt-6 flex items-center gap-3 font-mono text-[11px] tracking-[0.15em] uppercase text-muted-d">
                      <span className="text-sand">{t.name}</span>
                      <span className="h-px w-6 bg-line-d" />
                      <span>{t.role}, {t.company}</span>
                    </figcaption>
                  </figure>
                </Reveal>
              ))
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
